export default "__VITE_ASSET__DWmszlJY__"